import React from 'react';
import EatInformation from "../../components/moreinformation/EatInformation";

const Information = () => {
    return (
        <div>
            <EatInformation/>
        </div>
    );
};

export default Information;